import { ClientContext } from "ClientProvider";
import DivLoader from "components/divloader/DivLoader";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import React, { useContext } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
import { getToken } from "utils/auth";

export default function Admin(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const [permissionChecked, setPermissionChecked] = React.useState(false);
  const [currentRoute, setCurrentRoute] = React.useState("");

  React.useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 1300);
    };

    handleResize(); // run once initially

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { singleRoleData } = useContext(ClientContext);

  const checkPermission = (route: any) => {
    let isStatus = false;
    const r = singleRoleData?.[0];
    if (route === "gateway")        isStatus = r?.payment_method?.value?.view_payment_method_list;
    if (route === "subscription")   isStatus = r?.subscription?.value?.view_subscription_list;
    if (route === "clients")        isStatus = r?.client?.value?.view_client_list;
    if (route === "customers")      isStatus = r?.customers?.value?.view_customers;
    if (route === "api")            isStatus = r?.api?.value?.view_api_list;
    if (route === "settlement")     isStatus = r?.settlement?.value?.view_settlement_list;
    if (route === "organizations")  isStatus = r?.organization?.value?.view_organization_list;
    if (route === "blacklist")      isStatus = r?.blacklist?.value?.view_blacklist_list;
    if (route === "settings")       isStatus = r?.settings?.value?.view_settings;
    if (route === "transactions")   isStatus = r?.payment?.value?.view_payment_list;
    if (route === "tokens")         isStatus = r?.token?.value?.view_token_list;
    if (route === "payout")         isStatus = r?.payout?.value?.view_payout_list;
    if (route === "role")           isStatus = r?.role?.value?.view_role_list;
    if (route === "users")          isStatus = r?.user?.value?.view_user_list;
    if (route === "smart-routing")  isStatus = r?.client?.value?.client_gateway_routing;
    if (route === "client-details") isStatus = r?.client?.value?.client_gateway_settings || r?.client?.value?.customer_registration || r?.client?.value?.client_checkout_setting || r?.client?.value?.client_gateway_routing || r?.client?.value?.view_client || r?.client?.value?.view_client_treasury;
    if (route === "request-logs")   isStatus = r?.api_request_logs?.value?.view_api_request_logs;
    if (route === "audit-logs")     isStatus = r?.audit_logs?.value?.view_user_audit_logs;
    if (route === "kyc-velocity")   isStatus = r?.kyc_velocity?.value?.view_kyc_velocity;
    if (route === "crypto-payout")  isStatus = r?.crypto?.value?.view_crypto_payout_list || r?.crypto?.value?.view_single_crypto_payout_list;
    if (route === "crypto-payin")   isStatus = r?.crypto?.value?.view_crypto_payin;
    if (route === "fiat-payout")    isStatus = r?.fiat?.value?.view_fiat_payout_list || r?.fiat?.value?.view_single_fiat_payout_list;
    if (route === "dashboard")      isStatus = true;
    if (route === "profile")        isStatus = true;
    return isStatus;
  };

  React.useEffect(() => { getActiveRoute(routes); }, [location.pathname]);

  React.useEffect(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    let route_name = pathSegments[pathSegments.length - 1];
    if (route_name.length > 20 && /^[a-zA-Z0-9]+$/.test(route_name)) {
      route_name = pathSegments[pathSegments.length - 2];
    }
    const route_permission = checkPermission(route_name);
    if (route_permission !== undefined) setPermissionChecked(true);
    if (route_permission !== undefined && !route_permission) navigate("/admin/dashboard");
  }, [singleRoleData]);

  React.useEffect(() => {
    const token = getToken();
    if (!token) { navigate("/auth/sign-in", { replace: true }); window.location.reload(); }
  }, [navigate]);

  React.useEffect(() => {
    const token = getToken();
    if (!token) { navigate("/auth/sign-in", { replace: true }); window.location.reload(); }
  }, []);

  const getActiveRoute = (routes: RoutesType[]): string | boolean => {
    let activeRoute = "";
    const checkRoute = (route: RoutesType): boolean => {
      const fullPath = route.layout + "/" + route.path;
      if (window.location.href.includes(fullPath)) {
        activeRoute = route.name;
        setCurrentRoute(route.name);
        return true;
      }
      if (route.children) {
        for (const child of route.children) {
          if (window.location.href.includes(child.layout + "/" + child.path)) {
            activeRoute = child.name;
            setCurrentRoute(child.name);
            return true;
          }
        }
      }
      return false;
    };
    for (const route of routes) { if (checkRoute(route)) break; }
    return activeRoute || false;
  };

  const getActiveNavbar = (routes: RoutesType[]): string | boolean => {
    for (const route of routes) {
      if (window.location.href.indexOf(route.layout + route.path) !== -1) return route.secondary;
    }
    return false;
  };

  const getRoutes = (routes: RoutesType[]): any =>
    routes.map((prop, key) => {
      if (prop.layout === "/admin" && prop.children?.length > 0) {
        return prop.children.map((child, ci) => (
          <Route key={ci} path={child.path} element={child.component} />
        ));
      }
      if (prop.layout === "/admin") {
        return <Route path={`/${prop.path}`} element={prop.component} key={key} />;
      }
      return null;
    });

  document.documentElement.dir = "ltr";

  return (
    <div className="adm-root">
      <Sidebar open={open} onClose={() => setOpen(false)} />

      <div className="adm-content">
        <main className="adm-main">
          <Navbar
            onOpenSidenav={() => setOpen(!open)}
            brandText={currentRoute}
            secondary={getActiveNavbar(routes)}
            {...rest}
          />

          {permissionChecked ? (
            <div className="adm-page-wrap">
              <Routes>{getRoutes(routes)}</Routes>
            </div>
          ) : (
            <div className="adm-loading">
              <div className="adm-spinner" />
              <p className="adm-loading-text">Loading…</p>
            </div>
          )}
        </main>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .chakra-modal__overlay{
          z-index: 10 !important;
        }
        html, body {
          overflow-x: hidden;
        }
          
        .adm-root {
          display: flex;
          min-height: 100dvh;
          width: 100%;
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #f8fafc;
          overflow: hidden;
        }

        .adm-content {
          flex: 1; min-width: 0;
          display: flex; flex-direction: column;
           overflow: hidden;
        }

        @media (min-width: 1280px) {
          .adm-content { margin-left: 250px; }
        }

        .adm-main {
          flex: 1; display: flex; flex-direction: column;
          height: 100%; overflow: hidden;
        }

        .adm-page-wrap {
          flex: 1; overflow-y: auto; overflow-x: hidden;
          padding: 20px 24px 32px;
        }
        .adm-page-wrap::-webkit-scrollbar { width: 4px; }
        .adm-page-wrap::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        .adm-loading {
          flex: 1; display: flex; flex-direction: column;
          align-items: center; justify-content: center; gap: 12px;
          min-height: 80vh;
        }
        .adm-spinner {
          width: 32px; height: 32px;
          border: 3px solid #e2e8f0; border-top-color: #2563eb;
          border-radius: 50%; animation: admSpin 0.7s linear infinite;
        }
        @keyframes admSpin { to { transform: rotate(360deg); } }
        .adm-loading-text { font-size: 13px; color: #94a3b8; font-weight: 500; }

        /* Dark mode */
        .dark .adm-root { background: #0a0f1e; }
        .dark .adm-page-wrap::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); }
      `}</style>
    </div>
  );
}